/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_History_UnavailableInputs */

const cs_lustrace_history_unavailable = /** @type {(inputs: Lustrace_History_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historie zatím není k dispozici.`)
};

const en_lustrace_history_unavailable = /** @type {(inputs: Lustrace_History_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History is not available yet.`)
};

/**
* | output |
* | --- |
* | "History is not available yet." |
*
* @param {Lustrace_History_UnavailableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_history_unavailable = /** @type {((inputs?: Lustrace_History_UnavailableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_History_UnavailableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_history_unavailable(inputs)
	return cs_lustrace_history_unavailable(inputs)
});